// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import tr from "./locales/tr/translation.json";
import de from "./locales/de/translation.json";

const RTL = new Set(["ar", "he"]);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      de: { translation: de },
    },
    fallbackLng: "tr",
    supportedLngs: ["tr", "en", "de", "fr", "ar", "pt", "es", "ru", "it", "he"],
    nonExplicitSupportedLngs: true, // "en-US" -> "en"
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "cookie", "navigator", "htmlTag"],
      caches: ["localStorage", "cookie"],
    },
    // debug: true,
  });

// <html lang/dir> ayarı
const applyHtmlLangDir = (lng) => {
  const base = (lng || "tr").split("-")[0];
  document.documentElement.lang = base;
  document.documentElement.dir = RTL.has(base) ? "rtl" : "ltr";
};
applyHtmlLangDir(i18n.resolvedLanguage);
i18n.on("languageChanged", applyHtmlLangDir);

export default i18n;
